export const STARTED_NAVIGATOR_STEP = 'Started navigator step';
export const COMPLETED_NAVIGATOR_STEP = 'Completed navigator step';
